import { render, staticRenderFns } from "./SeleccionPantallas.vue?vue&type=template&id=6089ecf5&scoped=true"
import script from "./SeleccionPantallas.vue?vue&type=script&lang=js"
export * from "./SeleccionPantallas.vue?vue&type=script&lang=js"
import style0 from "./SeleccionPantallas.vue?vue&type=style&index=0&id=6089ecf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6089ecf5",
  null
  
)

export default component.exports